let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aYsQi")).then(() => parcelRequire('8RuHK'));